<script>
import ModalBus from '../../../../../event-bus/modal-bus';
import Segment from '../../../../../Segment';
import UpdateCreditCardPopup from './UpdateCreditCardPopup.vue';

export default {
  name: 'UpdateCreditCardHandler',
  methods: {
    openUpdateCreditCardPopup() {
      Segment.trackUserInteraction('UpdateCreditCardClicked');
      ModalBus.$emit('open', {
        component: UpdateCreditCardPopup,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/account-settings/UpdateCreditCardHandler.vue